import type { FC } from 'react';
import { useConditionalClickHandler } from '../../hooks/useConditionalClickHandler';
import { ListItem } from '../ListItem/ListItem';
import {
  type FloatingListItemProps,
  isFloatingListItemAnchor,
} from './FloatingList.types';
import { floatingListItemVariants } from './FloatingListItem.styles';

export const FloatingListItem: FC<FloatingListItemProps> = (props) => {
  const handleClick = useConditionalClickHandler<
    HTMLDivElement | HTMLAnchorElement
  >(props.disabled, props.onClick);

  const hasCustomContent = props.customContent !== undefined;

  return isFloatingListItemAnchor(props) ? (
    <ListItem
      {...props}
      renderAs='anchor'
      className={floatingListItemVariants({
        disabled: props.disabled,
        hasCustomContent,
        className: props.className,
      })}
      onClick={handleClick}
      disabled={false}
    />
  ) : (
    <ListItem
      {...props}
      renderAs='div'
      className={floatingListItemVariants({
        disabled: props.disabled,
        hasCustomContent,
        className: props.className,
      })}
      onClick={handleClick}
    />
  );
};
